import './Requests.scss';
import useRequestsVM from './useRequestsVM';
import { Loader } from 'components/Loader/Loader';

export type RequestsPageProps = {};

export const Requests: React.FC<RequestsPageProps> = () => {
    const { requests, formatDate, me, isApiRequestLoading, isComponentLoading } = useRequestsVM();

    type Status = 'Actif' | 'Inactif' | 'Ponctuel' | 'Sortie';

    const statusMap: Record<string, Status> = {
        active: 'Actif',
        inactive: 'Inactif',
        punctual: 'Ponctuel',
        out: 'Sortie'
    };

    if (isApiRequestLoading || isComponentLoading) {
        return (
            <main id="requests">
                <Loader />
            </main>
        );
    }

    return (
        <main id="requests">
            <div className="requests-list">
                {!requests.length && <div className="empty-state">Aucune demande n'a encore été faite</div>}
                {requests.map((request, index) => (
                    <div className="request" key={index}>
                        <div className="request-content">
                            <h2>Demande {request.reference}</h2>
                            <div className="request-label">
                                <h3>Intitulé</h3>
                                <p>{request.label}</p>
                            </div>
                            <div className="request-date">
                                <h3>Date de la demande</h3>
                                <p>{formatDate(request.created_at)}</p>
                            </div>
                            <div className="request-project">
                                <h3>Projet concerné</h3>
                                <p>{me.projects[0].initial_request}</p>
                            </div>
                            <div className="request-status">
                                <h3>Statut du projet</h3>
                                <p>{statusMap[me.status]}</p>
                            </div>
                        </div>
                        {request.observation && (
                            <div className="request-observation">
                                <h2>Commentaire</h2>
                                <div dangerouslySetInnerHTML={{ __html: request.observation }} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </main>
    );
};
